import {
  ContentRoute,
  createMapper,
  FullImageStoryContentGroup,
  RouteSlotInput,
} from '@caritas/ui';

import { mapImage } from '../Image.mappers';
import { mapHtmlBlock } from './HtmlBlock.mappers';

const mapBackgroundStoryContent = createMapper<
  Exclude<BlockBackgroundStoryFragment['bgStoryContent'], undefined>,
  RouteSlotInput<typeof FullImageStoryContentGroup, 'items'>
>({
  BlockHtmlParagraph: mapHtmlBlock,
  BlockHtmlList: mapHtmlBlock,
});

export function mapBackgroundStory(
  input: BlockBackgroundStoryFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'fullImageStoryBlock'> {
  return {
    key: 'fullImageStoryBlock',
    input: () => [
      {
        Image:
          input.bgStoryBackground?.__typename === 'MediaImage'
            ? mapImage({
                image: input.bgStoryBackground.image,
                preset: 'background_story',
                sizes: '(min-width: 1024px) 1600px, (min-width: 768px) 1200px, 100wv',
                caption: input.bgStoryBackground?.caption,
              })
            : undefined,
        MobileImage:
          input.bgStoryBackground?.__typename === 'MediaImage'
            ? mapImage({
                image: input.bgStoryBackground.image,
                preset: 'background_story_portrait',
                caption: input.bgStoryBackground?.caption,
              })
            : undefined,
        videoUrl:
          input.bgStoryBackground?.__typename === 'MediaVideo'
            ? input.bgStoryBackground.url
            : undefined,
        VideoImage:
          input.bgStoryBackground?.__typename === 'MediaVideo' &&
          input.bgStoryBackground.previewImage
            ? mapImage({
                image: input.bgStoryBackground.previewImage,
                preset: 'background_story_portrait',
                caption: input.bgStoryBackground?.description,
              })
            : undefined,
        content: {
          items: mapBackgroundStoryContent(input['bgStoryContent'] || []),
        },
        textPosition: input.textPosition,
        source:
          input.displaySource &&
          input.bgStoryBackground?.__typename === 'MediaImage'
            ? input.bgStoryBackground.source
            : '',
      },
      200,
    ],
  };
}
